const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaEstado: [],
	listaCidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PESSOA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PESSOA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'PESSOA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'PESSOA_ESTADO_SELECT_LISTADO':
			return {
				...state,
				listaEstado: action.payload.data
			};

		case 'PESSOA_CIDADE_SELECT_LISTADO':
			return {
				...state,
				listaCidade: action.payload.data
			};

        default:
            return state;
    }
}
